module.exports = __webpack_public_path__ + "img/0xbb8db5e17bbe9c90da8e3445e335b82d7cc53575.15ab009b.png";